import { organizationQueryKeys } from "@/api/query-keys/organizations"
import { useQuery } from "@tanstack/react-query"
import { getOrganizationStyle } from "../services/organization"
import { STALE_TIME_DAY } from "toptaal-shared"

export function useOrganizationStyleQuery() {
  return useQuery({
    queryKey: organizationQueryKeys.style(),
    queryFn: () => getOrganizationStyle(),
    staleTime: STALE_TIME_DAY,
    gcTime: STALE_TIME_DAY,
  })
}
